
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15.47 15.68"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M4.34 12.41h6.84v1.09H4.34zM5.44 14.58h4.63v1.09H5.44zM5.94 10.83V8.6H4.16l3.53-3.36 3.53 3.36H9.44v2.23zm.95-3.32H7v2.22h1.35V7.51h.14l-.8-.76z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M11.59 11.69V10.6a2.79 2.79 0 0 0 1.17-5.32l-.35-.16v-.39-.33a3.31 3.31 0 0 0-5.94-2l-.27.37-.41-.21a2.31 2.31 0 0 0-1.02-.26A2.38 2.38 0 0 0 2.4 4.67a2.53 2.53 0 0 0 .15.82l.17.44-.41.23a2.37 2.37 0 0 0 1.15 4.44v1.09A3.46 3.46 0 0 1 1.4 5.45 3.46 3.46 0 0 1 5.93 1.4a4.4 4.4 0 0 1 7.62 3v.07a3.87 3.87 0 0 1-2 7.22z"}})])])])
          )
        }
      }
    